import { useFixerContent } from '../hooks/i18n/usePageContent.js'
import { useFixerBriefForm } from '../hooks/ui/useFixerBriefForm.js'
import { FixerCard, FixerKicker } from './fixer-ui.js'

export function FixerBriefForm() {
  const content = useFixerContent()
  const f = content.briefForm
  const {
    formState,
    fieldErrors,
    isSubmitting,
    submitStatus,
    handleChange,
    handleSubmit,
  } = useFixerBriefForm({ nameRequired: f.nameRequired, emailRequired: f.emailRequired, emailInvalid: f.emailInvalid })

  return (
    <FixerCard id="fixer-brief-form">
      <form onSubmit={e => void handleSubmit(e)} noValidate aria-label={f.formAria} className="fixer-stack-md">
        <div>
          <FixerKicker channel="transmit">{f.kicker}</FixerKicker>
          <h3 className="fixer-subheading mt-2">{f.title}</h3>
        </div>

        <div className="fixer-form-grid-2">
          <div className="fixer-form-field">
            <label htmlFor="fixer-brief-name" className="fixer-form-label">
              {f.name} <span aria-hidden="true">*</span>
            </label>
            <input
              id="fixer-brief-name"
              name="name"
              type="text"
              value={formState.name}
              onChange={handleChange}
              required
              autoComplete="name"
              className={`fixer-form-input${fieldErrors.name ? ' is-error' : ''}`}
              aria-invalid={!!fieldErrors.name}
              aria-describedby={fieldErrors.name ? 'fixer-brief-name-error' : undefined}
            />
            {fieldErrors.name ? (
              <p id="fixer-brief-name-error" role="alert" className="fixer-form-error">{fieldErrors.name}</p>
            ) : null}
          </div>

          <div className="fixer-form-field">
            <label htmlFor="fixer-brief-company" className="fixer-form-label">{f.company}</label>
            <input
              id="fixer-brief-company"
              name="company"
              type="text"
              value={formState.company}
              onChange={handleChange}
              autoComplete="organization"
              className="fixer-form-input"
            />
          </div>
        </div>

        <div className="fixer-form-field">
          <label htmlFor="fixer-brief-email" className="fixer-form-label">
            {f.email} <span aria-hidden="true">*</span>
          </label>
          <input
            id="fixer-brief-email"
            name="email"
            type="email"
            value={formState.email}
            onChange={handleChange}
            required
            autoComplete="email"
            className={`fixer-form-input${fieldErrors.email ? ' is-error' : ''}`}
            aria-invalid={!!fieldErrors.email}
            aria-describedby={fieldErrors.email ? 'fixer-brief-email-error' : undefined}
          />
          {fieldErrors.email ? (
            <p id="fixer-brief-email-error" role="alert" className="fixer-form-error">{fieldErrors.email}</p>
          ) : null}
        </div>

        <div className="fixer-form-grid-2">
          <div className="fixer-form-field">
            <label htmlFor="fixer-brief-type" className="fixer-form-label">{f.productionType}</label>
            <select
              id="fixer-brief-type"
              name="productionType"
              value={formState.productionType}
              onChange={handleChange}
              className="fixer-form-input"
            >
              <option value="">{f.select}</option>
              {content.productionTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>

          <div className="fixer-form-field">
            <label htmlFor="fixer-brief-dates" className="fixer-form-label">{f.dates}</label>
            <input
              id="fixer-brief-dates"
              name="shootDates"
              type="text"
              value={formState.shootDates}
              onChange={handleChange}
              placeholder={f.datesPlaceholder}
              className="fixer-form-input"
            />
          </div>
        </div>

        <div className="fixer-form-grid-2">
          <div className="fixer-form-field">
            <label htmlFor="fixer-brief-region" className="fixer-form-label">{f.region}</label>
            <input
              id="fixer-brief-region"
              name="region"
              type="text"
              value={formState.region}
              onChange={handleChange}
              placeholder={f.regionPlaceholder}
              className="fixer-form-input"
            />
          </div>

          <div className="fixer-form-field">
            <label htmlFor="fixer-brief-crew" className="fixer-form-label">{f.crew}</label>
            <input
              id="fixer-brief-crew"
              name="crewSize"
              type="text"
              value={formState.crewSize}
              onChange={handleChange}
              placeholder={f.crewPlaceholder}
              className="fixer-form-input"
            />
          </div>
        </div>

        <div className="fixer-form-field">
          <label htmlFor="fixer-brief-message" className="fixer-form-label">{f.message}</label>
          <textarea
            id="fixer-brief-message"
            name="message"
            value={formState.message}
            onChange={handleChange}
            rows={4}
            placeholder={f.messagePlaceholder}
            className="fixer-form-input fixer-form-textarea"
          />
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <button type="submit" className="fixer-btn-primary w-full sm:w-auto" disabled={isSubmitting}>
            {isSubmitting ? f.sending : f.submit}
          </button>
          {submitStatus === 'success' ? (
            <p className="fixer-body-sm text-[var(--fc-accent)]" role="status">
              {f.success}
            </p>
          ) : null}
          {submitStatus === 'error' ? (
            <p className="fixer-form-error" role="alert">
              {f.error}
            </p>
          ) : null}
        </div>
      </form>
    </FixerCard>
  )
}
